const formatValue = (value: string | undefined): string => {
  return value
    ? Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
      }).format(Number(value))
    : '';
};

export default formatValue;
